import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useCurrency } from '@/contexts/CurrencyContext';
import { getUser } from '@/lib/common';

interface CurrencyToggleProps {
  budgetCurrency?: string;
  className?: string;
}

export const CurrencyToggle: React.FC<CurrencyToggleProps> = ({
  budgetCurrency,
  className,
}) => {
  const user = getUser();
  const { selectedCurrencyMode, setSelectedCurrencyMode } = useCurrency();

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newMode: 'user' | 'budget' | null,
  ) => {
    if (newMode) setSelectedCurrencyMode(newMode);
  };

  return (
    <Box className={className} sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'flex-end' }}>
      <Typography variant="body2" color="text.secondary">
        Currency
      </Typography>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={selectedCurrencyMode}
        onChange={handleChange}>
        <ToggleButton value="user">User ({user?.default_currency || 'USD'})</ToggleButton>
        {budgetCurrency && (
          <ToggleButton value="budget">Budget ({budgetCurrency})</ToggleButton>
        )}
      </ToggleButtonGroup>
    </Box>
  );
};


